// extracted by mini-css-extract-plugin
export default {"teamList":"team_teamList__VLXXf","title":"team_title__N4wJd"};